<template>
  <div class="app-main-menubar">
    <div class="profile-data d-flex flex-column justify-content-center align-items-center">
      <div class="profile-data-icon mb-1 d-flex justify-content-center align-items-center">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.33333 9.33317C9.33333 5.59984 12.2667 2.6665 16 2.6665C19.7333 2.6665 22.6667 5.59984 22.6667 9.33317C22.6667 13.0665 19.7333 15.9998 16 15.9998C12.2667 15.9998 9.33333 13.0665 9.33333 9.33317ZM28 25.3332V27.9998C28 28.7998 27.4667 29.3332 26.6667 29.3332C25.8667 29.3332 25.3333 28.7998 25.3333 27.9998V25.3332C25.3333 23.0665 23.6 21.3332 21.3333 21.3332H10.6667C8.4 21.3332 6.66667 23.0665 6.66667 25.3332V27.9998C6.66667 28.7998 6.13333 29.3332 5.33333 29.3332C4.53333 29.3332 4 28.7998 4 27.9998V25.3332C4 21.5998 6.93333 18.6665 10.6667 18.6665H21.3333C25.0667 18.6665 28 21.5998 28 25.3332ZM16 13.3332C13.7333 13.3332 12 11.5998 12 9.33317C12 7.0665 13.7333 5.33317 16 5.33317C18.2667 5.33317 20 7.0665 20 9.33317C20 11.5998 18.2667 13.3332 16 13.3332Z"
            fill="black"
          />
          <mask id="mask0_422_2296" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="4" y="2" width="24" height="28">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.33333 9.33317C9.33333 5.59984 12.2667 2.6665 16 2.6665C19.7333 2.6665 22.6667 5.59984 22.6667 9.33317C22.6667 13.0665 19.7333 15.9998 16 15.9998C12.2667 15.9998 9.33333 13.0665 9.33333 9.33317ZM28 25.3332V27.9998C28 28.7998 27.4667 29.3332 26.6667 29.3332C25.8667 29.3332 25.3333 28.7998 25.3333 27.9998V25.3332C25.3333 23.0665 23.6 21.3332 21.3333 21.3332H10.6667C8.4 21.3332 6.66667 23.0665 6.66667 25.3332V27.9998C6.66667 28.7998 6.13333 29.3332 5.33333 29.3332C4.53333 29.3332 4 28.7998 4 27.9998V25.3332C4 21.5998 6.93333 18.6665 10.6667 18.6665H21.3333C25.0667 18.6665 28 21.5998 28 25.3332ZM16 13.3332C13.7333 13.3332 12 11.5998 12 9.33317C12 7.0665 13.7333 5.33317 16 5.33317C18.2667 5.33317 20 7.0665 20 9.33317C20 11.5998 18.2667 13.3332 16 13.3332Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_422_2296)">
            <rect width="32" height="32" fill="#7367F0" />
          </g>
        </svg>
      </div>
      <div class="profile-data-info d-flex flex-column justify-content-center align-items-center">
        <span class="profile-data-info-name">{{  }}</span>
        <span class="profile-data-info-role">مدیر ساختمان</span>
      </div>
    </div>

    <div class="mt-5">
      <ul class="p-0">
        <li v-for="(menuItem, index) in menuItems" :key="index" class="menu-items mt-2 cursor-pointer">
          <div class="d-flex align-items-center justify-content-between" @click="menuItem.openDropdownIitem = !menuItem.openDropdownIitem">
            <!-- icon and route -->
            <div class="d-flex align-items-center">
              <span class="menu-item-icon mr-1 d-inline-flex justify-content-center align-items-center" :style="{ background: generateBgForBox(menuItem.iconBg) }">
                <component :is="menuItem.icon" :style="{ color: menuItem.iconBg }" />
              </span>
              <router-link :to="menuItem.to" v-if="!menuItem.dropdown" @click.native="closeMenu" class="menu-item-text">
                {{ menuItem.title }}
              </router-link>

              <!-- dropdown toggle -->
              <p class="m-0" v-if="menuItem.dropdown">
                {{ menuItem.title }}
              </p>
            </div>
            <!-- chevron-down-icon -->
            <div class="d-flex justify-content-end cursor-pointer" v-if="menuItem.dropdown">
              <img class="chevron-down-icon" :src="require('@/assets/icons/chevron-down-icon.svg')" alt="" draggable="false" width="15" :class="{ 'rotate-up': menuItem.openDropdownIitem }" />
            </div>
          </div>

          <!-- dropdown items -->
          <ul v-if="menuItem.dropdown && menuItem.openDropdownIitem" class="list-unstyled mt-2 px-1">
            <li v-for="(dropdownItem, index) in menuItem.dropdown" :key="index" class="mt-1" @click="closeMenu">
              <router-link :to="dropdownItem.to" @click.native="closeMenu" class="menu-item-text drop">
                {{ dropdownItem.title }}
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ChartIcon from "./svg-icons/ChartIcon.vue";
import PeopleIcon from "./svg-icons/PeopleIcon.vue";
import MoneyIcon from "./svg-icons/MoneyIcon.vue";
import BookIcon from "./svg-icons/BookIcon.vue";
import BoardIcon from "./svg-icons/BoardIcon.vue";
import BellIcon from "./svg-icons/BellIcon.vue";
import { generateBgForBox } from "../utils";

export default {
  components: {
    ChartIcon,
    PeopleIcon,
    MoneyIcon,
    BookIcon,
    BoardIcon,
    BellIcon,
  },
  data() {
    return {
        menuItems: [
            {
                title: "داشبورد",
                icon: "chart-icon",
                iconBg: "#28C76F",
                to: "/",
            },
        ],
    };
  },
  methods: {
    generateBgForBox,
    closeMenu() {
      this.$store.commit('app/UPDATE_IS_MAIN_MENU_OPEN')
    }
  },
};
</script>

<style lang="scss" scoped>
.app-main-menubar {
  position: fixed;
  left: 0 !important;
  right: 0 !important;
  top: 0 !important;
  z-index: 1005;
  background: #fff;
  width: 35rem !important;
  max-width: 35rem !important;
  margin: 0 auto;
  height: 100%;
  padding: 80px 20px;
  overflow: scroll;
}
@media only screen and (min-width: 250px) and (max-width: 600px) {
  .app-main-menubar {
    width: 100% !important;
  }
}

.profile-data-icon {
  width: 64px;
  height: 64px;
  background: #eeedfd;
  border-radius: 50%;
}
.profile-data-info-name {
  font-size: 18px;
  font-weight: 500;
}

.profile-data-info-role {
  font-size: 16px;
  font-weight: 300;
}
.menu-items {
  list-style: none;
  font-size: 16px;
  position: relative;
  padding-top: 5px;
  //**chevron-down-icon */
  img.chevron-down-icon {
    transition: all 0.3s linear;
    &.rotate-up {
      transform: rotate(-180deg);
      transition: all 0.3s linear;
    }
  }
}

.menu-item-text {
  color: #63587c;
  font-size: 16px;
  &.drop {
    display: inherit;
    width: 100%;
    font-size: 14px;
  }
}

.menu-items::before {
  position: absolute;
  display: block;
  content: '';
  top: -10px;
  left: 0;
  background: #f5f5f5;
  width: 100%;
  height: 1px;
}
.menu-item-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
</style>
